import script from "./galleryImageCutout.component.vue?vue&type=script&setup=true&lang=ts"
export * from "./galleryImageCutout.component.vue?vue&type=script&setup=true&lang=ts"

import "./galleryImageCutout.component.vue?vue&type=style&index=0&id=c4ed64ba&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4ed64ba"]])

export default __exports__